import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/work/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations } from 'vuex';
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import _variables from '@/styles/variables.scss';
export default {
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['permission_routes', 'sidebar'])), mapState('app', ['menuOpeneds', 'menuSearchKey'])), {}, {
    searchKey: {
      get: function get() {
        return this.$store.state.app.menuSearchKey;
      },
      set: function set(val) {
        this.$store.commit('app/SET_MENU_SEARCH_KEY', val);
      }
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      // 确保返回布尔值，避免 undefined
      return typeof this.sidebar.collapse === 'boolean' ? this.sidebar.collapse : false;
    },
    allMainMenuIndexes: function allMainMenuIndexes() {
      // 修复：使用 permission_routes 而非 routes
      return this.permission_routes.filter(function (route) {
        return !route.hidden;
      }).map(function (route) {
        return route.path;
      });
    }
  }),
  mounted: function mounted() {
    this.SET_MENU_OPENEDS([]);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['SET_MENU_OPENEDS'])), {}, {
    handleSearch: function handleSearch() {
      if (this.menuSearchKey.trim()) {
        this.SET_MENU_OPENEDS(this.allMainMenuIndexes);
      } else {
        this.SET_MENU_OPENEDS([]);
      }
    }
  })
};